import React from 'react';
import { Segment, Divider } from 'semantic-ui-react';
import { SemanticContainer, SemanticSegment } from './styled';

import { withRouter } from 'react-router-dom';
import AdminMenu from '../../../../components/Admin/MenuDetalhes/AdminMenu'
import Back from '../../../../components/Admin/Eventos/FormularioEmails/Back';
import FormularioEmail from '../../../../components/Admin/Eventos/FormularioEmails';

const EventosCadastro = props => {
  return (
    <>
      <AdminMenu />
      <SemanticContainer>
        <Back />
        <h2>Criar marcação para envio de e-mail</h2>
        <Divider />
        <Segment>
          <FormularioEmail />
        </Segment>
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment >
          Grupo Voitto <i class="copyright outline icon"></i>2020
        </SemanticSegment>
      </SemanticContainer>
    </>
  )
}

export default withRouter(EventosCadastro);